import React, { useEffect, useState } from "react";
import GetMonthsOpt from "../Dropdowns/getSelectMonth.js";
import GetYearsOpt from "../Dropdowns/getSelectYear.js";
import GetAllDistrictsAll from "../Dropdowns/getAllDistricts.jsx";
import GenericDropdown from "../Dropdowns/GenericDropdown.js";
import VerifyFPSWiseCommissionNFSAReportDetails from './VerifyFPSWiseCommissionNFSAReportDetails.jsx';
import axios from "axios";

const VerifyFPSWiseCommissionNFSAReport = () => {
  const [loading, setLoading] = useState(true);
  const [district, setDistrict] = useState("");
  const [userRole, setUserRole] = useState("0");
  const [districts, setDistricts] = useState([]);
  const [distCode, setDistCode] = useState("0");
  const [userName, setUserName] = useState("");
  const [sessionExpired, setSessionExpired] = useState(false);
  const [sessionLoading, setSessionLoading] = useState(true);
  const [renderContent, setRenderContent] = useState(null);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_URL}/api/ekyc-abstract/session-info`, {
        withCredentials: true,
      })
      .then((res) => {
        setUserRole(res.data.userRole || "0");
        setUserName(res.data.loginUserName || "");
        setSessionExpired(false);
      })
      .catch(() => {
        setSessionExpired(true);
        setUserRole("0");
      })
      .finally(() => {
        setSessionLoading(false);
      });

       axios.get(`${process.env.REACT_APP_URL}/api/fps/districts`).then(res => {
          setDistricts(res.data);      
      });
  }, []);



  // Loading handler
  const handleLoadingChange = (isLoading) => setLoading(isLoading);

  // District change
  const handleDistrictChange = (selectedCode) => {
    setDistCode(selectedCode);

    const match = districts.find((d) => d.dist_code === selectedCode);
    setDistrict(
      !selectedCode || selectedCode === "0"
        ? "ALL"
        : match
        ? match.dist_name_en
        : ""
    );
  };

  const buildReportTitle = () => {
  const monthVal = document.getElementById('month')?.value || '';
  const yearVal = document.getElementById('year')?.value || '';
  const allotMonthVal = document.getElementById('allot_month')?.value || '';
  const allotYearVal = document.getElementById('allot_year')?.value || '';

  const distMonthName = document.getElementById("month").options[document.getElementById("month").selectedIndex].text; 
  const alotMonthName = document.getElementById("allot_month").options[document.getElementById("allot_month").selectedIndex].text;      
  const commName = document.getElementById("comm_id").options[document.getElementById("comm_id").selectedIndex].text;
  
  const distributionMonth = distMonthName || '';
  const distributionYear = yearVal || '';
  const allottedMonth = alotMonthName || '';
  const allottedYear = allotYearVal || '';
  const commodityDisplay = commName || '';
  const districtName = district || 'ALL';  

  return `NFSA Commission Report for Distribution: ${distributionMonth}'${distributionYear} , Allotment: ${allottedMonth}'${allottedYear} ,District: ${districtName}, Commodity: ${commodityDisplay} `;
  };


  // useEffect(() => {
  //           if (userRole === "2" && userName && districts.length > 0) {
  //             // Find district where dist_name_en matches userName (case-insensitive)
  //             const matchedDistrict = districts.find(
  //               (d) => d.dist_name_en.toLowerCase() === userName.toLowerCase()
  //             );
        
  //             if (matchedDistrict) {
  //               setDistCode(matchedDistrict.dist_code);
  //               setDistrict(matchedDistrict.dist_name_en);
  //             } else {
  //               setDistCode("0");
  //               setDistrict("ALL");
  //             }
  //           }
  //         }, [userRole, userName, districts]);

   useEffect(() => {
  if (userRole !== "2" || !districts) return;

  const districtList = Array.isArray(districts) ? districts : [districts];

  if (districtList.length === 1) {
    const { dist_code, dist_name } = districtList[0];
    setDistCode(dist_code);
    setDistrict(dist_name);
  }
}, [userRole, districts]);

  const handleSubmit = () => {
  const month = document.getElementById("month")?.value || "";
  const year = document.getElementById("year")?.value || "";
  const allot_month = document.getElementById("allot_month")?.value || "";
  const allot_year = document.getElementById("allot_year")?.value || "";
  const comm_id = document.getElementById("comm_id")?.value || "";

  if (!month) return alert("Please select Distribution Month");
  if (!year) return alert("Please select Distribution Year");
  if (!allot_month) return alert("Please select Allotted Month");
  if (!allot_year) return alert("Please select Allotted Year");
  if (!comm_id) return alert("Please select Commodity");

  setRenderContent(null);

  const title = buildReportTitle();

  setTimeout(() => {
    setRenderContent(
      <VerifyFPSWiseCommissionNFSAReportDetails
        month={month}
        year={year}
        allotMonth={allot_month}
        allotYear={allot_year}
        commId={comm_id}
        distCode={distCode}
        reportTitle={title}
      />
    );
  }, 0);
};


  return (
    <div className="wrapper row3" style={{  paddingBottom: "40px" }}>
      <div id="container">
        <div style={{ display: "flex", justifyContent: "center", marginBottom: "10px" }}>
          <table width="55%">
            <thead>
              <tr className="tableheader">
                <th colSpan={12}>NFSA Commission Report for Verification</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>Distribution Month :</td>
                <td>
                  <GetMonthsOpt input_id="month" onLoadingChange={handleLoadingChange} />
                </td>

                <td>Distribution Year :</td>
                <td>
                  <GetYearsOpt input_id="year" onLoadingChange={handleLoadingChange} />
                </td>

                <td>Allotted Month :</td>
                <td>
                  <GetMonthsOpt input_id="allot_month" onLoadingChange={handleLoadingChange} />
                </td>

                <td>Allotted Year :</td>
                <td>
                  <GetYearsOpt input_id="allot_year" onLoadingChange={handleLoadingChange} />
                </td>

                <td><b>District</b></td>
                <td>
                  {["1", "9", "10","22"].includes(userRole) ? (
                    <GetAllDistrictsAll onLoadingChange={handleLoadingChange} onChange={handleDistrictChange} />
                  ) : userRole === "2" ? (
                    <>
                      <input type="hidden" id="dist_code" value={distCode} />
                      <div>{userName}</div>
                    </>
                  ) : (
                    <span>N/A</span>
                  )}
                </td>

                <td>Commodity</td>
                <td>
                  <GenericDropdown
                    tab="common.commodity_master"
                    code="comm_id"
                    name="comm_name_en"
                    whfld="status"
                    whval="A"
                    whfld1="nfsa_comm"
                    whval1="N"
                    dropdownName="comm_name"
                    dropdownId="comm_id"
                    JSONKey="id"
                    JSONValue="name"
                  />
                </td>
              </tr>

              <tr>
                <td colSpan="14" align="center">
                  <button className="button button2" style={{ marginRight: "10px" }} onClick={handleSubmit}>
                    Submit
                  </button>
                  <button className="button button2" onClick={() => window.history.back()}>
                    Back
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <br />

        <div id="loading" style={{ display: "none", textAlign: "center" }}>
          <img src="images/progress.gif" alt="Loading" />
        </div>

        <div id="detailsStateCommission">{renderContent}</div>
      </div>
    </div>
  );
};

export default VerifyFPSWiseCommissionNFSAReport;
